module.exports = __webpack_public_path__ + "img/ssclick-sad.6ab5f904.png";